/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Foxit_PriceInputs */

const en_pc_alt_t_foxit_price = /** @type {(inputs: Pc_Alt_T_Foxit_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paid, as a subscription or a one-time license`)
};

const zh_pc_alt_t_foxit_price = /** @type {(inputs: Pc_Alt_T_Foxit_PriceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`付费，提供订阅或一次性买断授权`)
};

/**
* | output |
* | --- |
* | "Paid, as a subscription or a one-time license" |
*
* @param {Pc_Alt_T_Foxit_PriceInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_foxit_price = /** @type {((inputs?: Pc_Alt_T_Foxit_PriceInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Foxit_PriceInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_foxit_price(inputs)
	return zh_pc_alt_t_foxit_price(inputs)
});
export { pc_alt_t_foxit_price as "pc.alt.t.foxit.price" }